import { CSSProperties } from "react";

const sliderThumbStyle = (
  mobileView: boolean,
  dialStyleRight: boolean,
  orientation: string,
  isDesktopView: boolean,
) => {
  const style = {
    transform: null,
    rotate: null,
  };
  if (!dialStyleRight && (isDesktopView || mobileView)) {
    return style;
  }
  if (dialStyleRight || mobileView) {
    return {
      transform: "translateX(250%)",
      rotate: "90deg",
    };
  }
  if (
    orientation === "landscape" ||
    (orientation === "portrait" && !isDesktopView)
  ) {
    return {
      transform: "translateX(250%)",
      rotate: "90deg",
    };
  }
  return style;
};

export const dialSliderStyle = (
  mobileView: boolean,
  lastIndexOfSliderLabel: number,
  dialStyleRight: boolean,
  mainColor: string,
  orientation: string,
  isDesktopView: boolean,
) => ({
  ...(dialStyleRight && { marginLeft: 0.5 }),
  boxShadow: "none",
  zIndex: 1302,
  "& .MuiSlider-valueLabel": {
    lineHeight: 1.2,
    fontSize: 12,
    background: "unset",
    padding: 0,
    width: 32,
    height: 32,
    borderRadius: "50% 50% 50% 0",
    backgroundColor: mainColor,
    color: mainColor,
    transformOrigin: "bottom left",
    transform: "translate(50%, -100%) rotate(-45deg) scale(0)",
    "&::before": { display: "none" },
    "&.MuiSlider-valueLabelOpen": {
      transform: "translate(50%, -100%) rotate(-45deg) scale(1)",
    },
    "& > *": {
      transform: "rotate(45deg)",
    },
  },
  "& .MuiSlider-markLabel": {
    width: lastIndexOfSliderLabel > 5 ? "100px" : "200px",
    justifyContent: "center",
    whiteSpace: "normal",
    color: mainColor,
    left: "-455%",
    fontSize: { md: 14, sm: 12 },
    textAlign: "center",
    ' &[data-index="0"]': {
      marginLeft: 1,
    },
  },

  "& .MuiSlider-mark": {
    backgroundColor: mainColor,
    height: "10px",
    width: "10px",
    borderWidth: 1,
    borderStyle: "solid",
    borderRadius: 20,
    opacity: 1,
  },

  "& .MuiSlider-thumb": {
    background: "none",
    boxSizing: "border-box",
    boxShadow: "none",
    paddingLeft: 0.8,
    border: "none",
    ...sliderThumbStyle(mobileView, dialStyleRight, orientation, isDesktopView),
  },
  ".MuiSlider-thumb.Mui-focusVisible, .MuiSlider-thumb:hover ": {
    boxShadow: "none !important",
  },
});

export const playPauseButtonStyle: CSSProperties = {
  position: "absolute",
  top: "50%",
  left: "48%",
  transform: "translate(-40%, -50%)",
  fontSize: "1.9rem",
  color: "#fff",
  background: "rgba(0,0,0,0.5)",
  padding: "0px 0px 0px 5px",
  border: "none",
  borderRadius: "50%",
  width: "90px",
  height: "90px",
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  cursor: "pointer",
};

export const sliderWrapper = (
  sliderOreintation: string,
  mobileView: boolean,
) => {
  return {
    ...(sliderOreintation == "horizontal"
      ? { width: "100%", paddingX: 1 }
      : { width: "100%" }),
    display: "flex",
    justifyContent: "center",
    paddingY: 2,

    height: mobileView ? "40vh" : "100%",
    flexDirection: "row",
    alignItems: "end",
  };
};
